export const contact = {
  email: "khedidabdellah@gmail.com",
  phoneNumber: "+39 352 294 7771",
  streetAdress: "",
  stateFull: "",
  city: "Italy",
};

export const form = {
  mySite: "https://www.khedid.com/"
};
